import { Injectable }               from '@angular/core';

import { FormControl , FormArray}						    from '@angular/forms';



@Injectable()
export class CommonValidationService { 
    
    tanzeel: any = window["DATA"];
	
    constructor(){}
	
}

export function validateCustomRequired(c: FormControl):any {
		if(c.value==null){
			return {"required":true};
		}
		if( c.value.trim == undefined ){
			//console.info( " its undefined " );
		}
		if( c.value != null && c.value.trim!= undefined &&c.value.trim().length <=0){
			return {"required":true};
		}
	}
	
export function validateFormArray(c: FormArray):any {
	var resp = {"required": true};
	for( var i = 0; i < c.controls.length; i++){
		if(c.controls[i] !=null && c.controls[i].value != false)
			resp = null;
	}
	return resp;
}

export function validatePhoneNo(c: FormControl):any {
            if( c.value == null || c.value == '' ){
                return null;
            }
            let phonenoExp:any = /^\+?[0-9 )(-]{4,20}$/;   
            if(!phonenoExp.test( c.value )){
                return {"phoneInvalid":true};
            }
            else {
                return null;
            }
}

export function validateNameField(c: FormControl):any {
	let nameExp:any = /^[A-Za-z _]+$/;
	if(!nameExp.test( c.value )){
		return {"nameInvalid":true};
	}
	else {
		return null;
	}
}